import { createFileRoute } from '@tanstack/react-router'
import { WeekdayPlayground } from '@/features/admin/weekday-playground'

export const Route = createFileRoute('/_authenticated/admin/weekday-playground')(
  {
    component: WeekdayPlayground,
  }
)
